// client/src/helpers/profileMeta.ts
function toDate(value?: string | Date | null): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "June 2026" — the account's join month. Null when absent/invalid. */
export function formatJoinDate(value?: string | Date | null): string | null {
  const d = toDate(value);
  if (!d) return null;
  return d.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

/** Relative last-active label: today / yesterday / N days ago / "Mon YYYY". */
export function formatRelativeDay(value?: string | Date | null): string | null {
  const d = toDate(value);
  if (!d) return null;
  const dayMs = 24 * 60 * 60 * 1000;
  const startOf = (x: Date) =>
    Date.UTC(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate());
  const diffDays = Math.round((startOf(new Date()) - startOf(d)) / dayMs);
  if (diffDays <= 0) return 'today';
  if (diffDays === 1) return 'yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  return d.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
